import { render, staticRenderFns } from "./tenantInvoice.vue?vue&type=template&id=2d4625e3&scoped=true"
import script from "./tenantInvoice.vue?vue&type=script&lang=js"
export * from "./tenantInvoice.vue?vue&type=script&lang=js"
import style0 from "./tenantInvoice.vue?vue&type=style&index=0&id=2d4625e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4625e3",
  null
  
)

export default component.exports